<template>
  <div class="mx-6 my-6">
    <div class="d-flex align-center mb-6">
      <h1 class="display-1 font-weight-regular mb-0">
        Totali ultima distribuzione: {{ deliveryDateText }}
      </h1>
      <v-spacer />
      <v-btn small outlined color="primary" @click="fetchTotals" :loading="loading">
        <i class="fas fa-rotate-right mr-2" /> Aggiorna
      </v-btn>
    </div>

    <v-alert v-if="error" type="error" dense outlined class="mb-4">
      {{ error }}
    </v-alert>

    <v-skeleton-loader v-if="loading" type="image, image" class="mb-4" />

    <v-row v-if="!loading" dense>
      <v-col cols="12" sm="6" md="3" v-for="card in cards" :key="card.key">
        <v-card class="pa-4" outlined>
          <div class="d-flex align-center mb-2">
            <v-avatar color="primary" size="36" class="mr-3" tile>
              <v-icon color="white" small>fas fa-percent</v-icon>
            </v-avatar>
            <div class="subtitle-2 grey--text text--darken-1">IVA {{ card.vat }}%</div>
          </div>
          <div class="headline font-weight-bold">{{ formatMoney(card.value || 0) }}</div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'DistTotalsByVat',
  data () {
    return {
      loading: false,
      error: null,
      totals: null
    }
  },
  computed: {
    deliveryDateText () {
      if (!this.totals?.deliveryDate) return '-'
      return this.formatDate(this.totals.deliveryDate)
    },
    cards () {
      return [
        { key: 'vat4', vat: 4, value: this.totals?.vat4 },
        { key: 'vat5', vat: 5, value: this.totals?.vat5 },
        { key: 'vat10', vat: 10, value: this.totals?.vat10 },
        { key: 'vat22', vat: 22, value: this.totals?.vat22 }
      ]
    }
  },
  mounted () {
    this.fetchTotals()
  },
  methods: {
    async fetchTotals () {
      this.loading = true
      this.error = null
      try {
        const { data } = await this.$http.get('v1/distribution/session/totals-by-vat')
        this.totals = data
      } catch (e) {
        this.error = 'Impossibile caricare i totali. Riprova.'
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>
</style>
